import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import CartIcon from '@material-ui/icons/ShoppingCart';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import CheckIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Cancel';
import Tooltip from '@material-ui/core/Tooltip';

import { Context as CartContext } from '../../context/cart.context';
import { Context as PropertyContext } from '../../context/property.context';
import { Context as AuthContext } from '../../context/auth.context';
import ControlMessage from "./ControlMessage";
import PaymentOptions from "./PaymentOptions";

var axios = require('axios');
var qs = require('qs');

const Overview = (props) => {
    const [itemInCart, setItemInCart] = useState(false);
    const { state, setCartVisible, addToCart } = useContext(CartContext);
    const propertyState = useContext(PropertyContext);
    const auth = useContext(AuthContext);
    const [controlMessageOpen, setControlMessageOpen] = React.useState(false);
    const [paymentOptionsOpen, setPaymentOptionsOpen] = React.useState(false);
    const [controlMessage, setControlMessage] = React.useState('');
    const [controlOrder, setControlOrder] = React.useState('');

    const { opID, id } = useParams();
    let location = useLocation();

    useEffect(() => {
        alreadyInCart();
    });

    const alreadyInCart = () => {
        const result = state.shoppingCart.find(
            ({ invoiceID }) => invoiceID === location.state.item.invoiceID
        );

        setItemInCart(result ? true : false);
    };

    const cartContainsNewestInvoice = (arr, target) => {
        return target.every(v => arr.includes(v));
    } 

    const disableAddToCartButton = () => {
        // control order logic :
        //  -1 = display only
        //  0 = Green Light to process
        //  1 = Good to process but another invoice is depenent on it being paid first
        //  2-Infinity = requeires all the lower numbers to be paid first. Or have them in the shopping cart to be paid at the same time.
    
        if(location.state.item.controlOrder == -1){
          return true;
        }
    
        if(location.state.item.controlOrder == 0 || location.state.item.controlOrder == 1 ){
          return false;
        }
    
        var invoiceIdsInCart = [];
        state.shoppingCart.forEach(element => {
            //Insure that the full balance was added and just not payment option.
            if(element.finalBalanceCheck >= element.balance){
                invoiceIdsInCart.push(element.invoiceID)
            }
        });
    
        if(cartContainsNewestInvoice(invoiceIdsInCart, location.state.item.controlInvoicesRequiredFirst)){
          return false;
        }
    
        return true;
      }

    return (
        <>
            <div style={styles.row}>
                <div style={{ width: '48%' }} id="bill-info">
                    <h3 style={{ borderBottom: '1px solid black' }}>
                        Bill Information
                    </h3>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td>Name:</td>
                                <td>
                                    {propertyState.state.taxBill.billInfo.name}
                                </td>
                            </tr>
                            <tr>
                                <td>Bill Address:</td>
                                <td>
                                    {propertyState.state.taxBill.billInfo.address}
                                    
                                     
                                    { propertyState.state.taxBill.billInfo.address2 ? (
                                        <>
                                            {', '}
                                            {propertyState.state.taxBill.billInfo.address2}
                                            <br />{' '}
                                       </>
                                    ) : (
                                        <>
                                            <br />{' '}
                                        </>
                                    )}
                                        

                                    {propertyState.state.taxBill.billInfo.city},{' '}
                                    {propertyState.state.taxBill.billInfo.state}
                                    {' '}
                                    {propertyState.state.taxBill.billInfo.zipcode}
                                </td>
                            </tr>


                            {auth.state.merchant.enableCoris == 1 && (
                                <tr>
                                    <td>Case Number:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.billInfo
                                                .caseNumber
                                        }
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td>{auth.state.merchant.enableCoris == 1 ? 'Citiation Number' : auth.state.merchant.accountLabel}:</td>
                                <td>

                                    { auth.state.merchant.enableCoris == 1 && propertyState.state.taxBill.billInfo.caseNumber != propertyState.state.taxBill.billInfo.account && (
                                        propertyState.state.taxBill.billInfo.account
                                    )}

                                    {auth.state.merchant.enableCoris != 1 && (
                                        propertyState.state.taxBill.billInfo.account
                                    )}
                                </td>
                            </tr>

                            {!auth.state.merchant.enableCoris == 1 && (
                                <>
                                    <tr>
                                        <td>Type:</td>
                                        <td>
                                            { propertyState.state.taxBill.billInfo.recordType }
                                        </td>
                                    </tr>

                                    {!auth.state.merchant.customerAddressInSearch || auth.state.merchant.customerAddressInSearch != true && (
                                        <tr>
                                            <td>{auth.state.merchant.physicalAddressLabel}:</td>
                                            <td>
                                                { propertyState.state.taxBill.billInfo.location }
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td>{auth.state.merchant.parcelLabel}:</td>
                                        <td>
                                            { propertyState.state.taxBill.billInfo.parcelNumber}
                                        </td>
                                    </tr>
                                
                                    <tr>
                                        <td>Tax Year:</td>
                                        <td>
                                            { propertyState.state.taxBill.billInfo.taxYear }
                                        </td>
                                    </tr>
                                </>
                            )}

                        </tbody>
                    </table>
                </div>
                <div style={{ width: '48%' }} id="bill-info">
                    <h3 style={{ borderBottom: '1px solid black' }}>
                        Payment Information
                    </h3>
                    <table style={{ width: '100%' }}>
                        <tbody>

                            <tr>
                                <td>Due Date:</td>
                                <td>
                                    {
                                        propertyState.state.taxBill.paymentInfo.dueDate
                                    }
                                </td>
                            </tr>

                            <tr>
                                <td>Status:</td>
                                <td
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        background: propertyState.state.taxBill
                                            .paymentInfo.paid || propertyState.state.taxBill.paymentInfo.totalDueNoFormat <= 0
                                            ? '#d4edda'
                                            : '#f8d7da',
                                        border: propertyState.state.taxBill
                                            .paymentInfo.paid || propertyState.state.taxBill.paymentInfo.totalDueNoFormat <= 0
                                            ? '1px solid #c3e6cb'
                                            : '1px solid #f5c6cb',
                                    }}
                                >
                                    {(propertyState.state.taxBill.paymentInfo.paid || propertyState.state.taxBill.paymentInfo.totalDueNoFormat <= 0) ? (
                                        <CheckIcon
                                            style={{
                                                color: 'green',
                                                marginRight: 8,
                                            }}
                                        />
                                    ) : (
                                        <ErrorIcon
                                            style={{
                                                color: 'red',
                                                marginRight: 8,
                                            }}
                                        />
                                    )}

                                    {propertyState.state.taxBill.paymentInfo
                                        .paid === 1
                                        ? 'Paid'
                                        : (propertyState.state.taxBill.paymentInfo.totalDueNoFormat <= 0 ? 'No Balance Due' : 'Unpaid')}
                                </td>
                            </tr>


                            { !auth.state.merchant.enableCoris == 1 && (
                                <>
                                    <tr>
                                        <td>Base Tax:</td>
                                        <td>
                                            { propertyState.state.taxBill.paymentInfo.baseTax}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Interest:</td>
                                        <td>
                                            { propertyState.state.taxBill.paymentInfo.interest}
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td>Fees:</td>
                                        <td>
                                            { propertyState.state.taxBill.paymentInfo.fees}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Amount Paid:</td>
                                        <td>
                                            { propertyState.state.taxBill.paymentInfo.amountPaid }{propertyState.state.taxBill.paymentInfo.lastPaymentDate != '' &&(<>, {propertyState.state.taxBill.paymentInfo.lastPaymentDate} </>)}
                                        </td>
                                    </tr>
                                </>
                            )}
                            { auth.state.merchant.enableCoris == 1 && propertyState.state.taxBill.paymentInfo.dueDate != '' && (
                                <tr>
                                    <td>Recurring Payment:</td>
                                    <td>
                                        { propertyState.state.taxBill.paymentInfo.recurringPaymentAmount }
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td>Total Due:</td>
                                <td>
                                    { propertyState.state.taxBill.paymentInfo.totalDue }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>



            {auth.state.merchant.enableCoris == 1 && (
                <>
                    <div style={{ width: '100%%' }} id="property-details-full">
                        <h3 style={{ borderBottom: '1px solid black' }}>
                            Violation Details
                        </h3>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr
                                    style={{
                                        width: '100%',
                                        paddingBottom: 20,
                                        background: '#ECF1F5',
                                    }}
                                >
                                    <th>Violation</th>
                                    <th>Code</th>
                                    <th>Date</th>
                                    <th>Location</th>

                                </tr>
                                {propertyState.state.taxBill.caseCharges.map((charge) => {
                                    return (
                                        <tr>
                                            <td>
                                                {charge.violDescr}
                                            </td>
                                            <td>
                                                {charge.violCode}
                                            </td>
                                            <td>
                                                { charge.violDatetime }
                                            </td>
                                            <td>
                                                { charge.violLocn}
                                            </td>
                
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: '100%%' }} id="property-details-mobile">
                        <h3 style={{ borderBottom: '1px solid black' }}>
                            Violation Details
                        </h3>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                {propertyState.state.taxBill.caseCharges.map((charge) => {
                                    return (
                                        <>
                                            <tr>
                                                <td>Violation:</td>
                                                <td>
                                                    {charge.violDescr}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Code:</td>
                                                <td>
                                                    {charge.violCode}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Date:</td>
                                                <td>
                                                    { charge.violDatetime }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Location:</td>
                                                <td>
                                                    { charge.violLocn}
                                                </td>
                                            </tr>
                                            <br />
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            )}







            {!auth.state.merchant.enableCoris == 1 && (
                <>
                    <div style={{ width: '100%%' }} id="property-details-full">
                        <h3 style={{ borderBottom: '1px solid black' }}>
                            Property Details
                        </h3>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr
                                    style={{
                                        width: '100%',
                                        paddingBottom: 20,
                                        background: '#ECF1F5',
                                    }}
                                >
                                    <th>ID</th>
                                    <th>District</th>
                                    <th>Appraisal</th>
                                    <th>Assessed</th>
                                    <th>Due</th>
                                    <th>Description</th>
                                </tr>
                                <tr>
                                    <td>
                                        {propertyState.state.taxBill.propertyDetails.id}
                                    </td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .district
                                        }
                                    </td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .appraisal
                                        }
                                    </td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .assessed
                                        }
                                    </td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .amountDue
                                        }
                                    </td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .description
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ width: '100%%' }} id="property-details-mobile">
                        <h3 style={{ borderBottom: '1px solid black' }}>
                            Property Details
                        </h3>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>ID:</td>
                                    <td>
                                        {propertyState.state.taxBill.propertyDetails.id}
                                    </td>
                                </tr>
                                <tr>
                                    <td>District:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .district
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Appraisal:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .appraisal
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Assessed:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .assessed
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Due:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .amountDue
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Description:</td>
                                    <td>
                                        {
                                            propertyState.state.taxBill.propertyDetails
                                                .description
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            <div style={{ width: '100%', textAlign: 'right', marginTop: 50 }}>


                {!propertyState.state.taxBill.paymentInfo.paid &&
                propertyState.state.taxBill.paymentInfo.totalDueNoFormat > 0 &&
                !itemInCart ? (
                    // {/* <Tooltip title={location.state.item.controlMessage}> */}
                        <Button
                            variant="contained"
                            color="primary"
                            style={{
                                color: disableAddToCartButton() ? "black" : "white",
                                background: disableAddToCartButton() ? "#e0e0e0" : "#009ade",
                            }}
                            startIcon={<CartIcon />}
                            onClick={() => {
                                if(!disableAddToCartButton()){
                                    if(typeof location.state.item.paymentOptions !== null && location.state.item.paymentOptions && location.state.item.paymentOptions.length >= 1){
                                        setPaymentOptionsOpen(true);
                                      } else {
                                        addToCart(location.state.item);
                                      }
                                } else {
                                    setControlMessage(location.state.item.controlMessage)
                                    setControlOrder(location.state.item.controlOrder)
                                    setControlMessageOpen(true)
                                }
                            }}
                        >
                            {(typeof location.state.item.paymentOptions !== null && location.state.item.paymentOptions && location.state.item.paymentOptions.length >= 1 ? "Options" :"Add To Cart")}
                            
                        </Button>
                    //{/* </Tooltip> */}
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CartIcon />}
                        disabled
                    >
                        Add To Cart
                    </Button>
                )}
            </div>
            <ControlMessage
                modalOpen={controlMessageOpen}
                controlMessage={controlMessage}
                controlOrder={controlOrder}
                setModalOpen={setControlMessageOpen}
            />
            <PaymentOptions
                modalOpen={paymentOptionsOpen}
                cartItem={location.state.item}
                setModalOpen={setPaymentOptionsOpen}
            />
        </>
    );
};

const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
};

export default Overview;
